import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { generateScProps } from 'src/utils'

const StyledWrapper = styled.div`
  display: block;
`

const StyledInner = styled.div`
  height: 100%;
  width: 100%;

  ${ props => props.scAspectRatio && css`
    padding-top: ${ props => props.scAspectRatio * 100 + '%' };
    position: relative;
  ` }
`

const StyledImg = styled.img`
  height: 100%;
  object-fit: ${ p => p.scFit };
  width: 100%;

  ${ p => p.scAspectRatio && css`
    left: 0;
    position: absolute;
    top: 0;
  ` }
`

class ArBaseImage extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
    scAspectRatio: PropTypes.number,
    scFit: PropTypes.string,
  }

  state = {
    loaded: false,
  }

  componentDidMount () {
    this.setState({
      loaded: true,
    })
  }

  render () {
    const { className, src, alt } = this.props
    const scProps = generateScProps(this.props)
    return (
      <StyledWrapper className={className}>
        <StyledInner { ...scProps }>
          {this.state.loaded && <StyledImg srcset={src} src={src} alt={alt || ''} { ...scProps } />}
        </StyledInner>
      </StyledWrapper>
    )
  }
}

export default ArBaseImage
